import { render, staticRenderFns } from "./about.vue?vue&type=template&id=1ec594d3&scoped=true"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"
import style0 from "./about.styl?vue&type=style&index=0&id=1ec594d3&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec594d3",
  null
  
)

export default component.exports